import { storableError } from '../../util/errors';
import { updateProfile as updateProfileAction } from '../ProfileSettingsPage/ProfileSettingsPage.duck';

// ================ Action types ================ //
export const UPDATE_STORE_FAQS_REQUEST =
    'app/StoreFaqsPage/UPDATE_STORE_FAQS_REQUEST';
export const UPDATE_STORE_FAQS_SUCCESS =
    'app/StoreFaqsPage/UPDATE_STORE_FAQS_SUCCESS';
export const UPDATE_STORE_FAQS_ERROR =
    'app/StoreFaqsPage/UPDATE_STORE_FAQS_ERROR';

// ================ Reducer ================ //
const initialState = {
    updateInProgress: false,
    updateError: null,
};

export default function reducer(
    state = initialState,
    action = {}
) {
    const { type, payload } = action;
    switch (type) {
        case UPDATE_STORE_FAQS_REQUEST:
            return { ...state, updateInProgress: true, updateError: null };
        case UPDATE_STORE_FAQS_SUCCESS:
            return { ...state, updateInProgress: false, updateError: null };
        case UPDATE_STORE_FAQS_ERROR:
            return { ...state, updateInProgress: false, updateError: payload };
        default:
            return state;
    }
}

// ================ Action creators ================ //
export const updateStoreFaqsRequest = () => ({ type: UPDATE_STORE_FAQS_REQUEST });
export const updateStoreFaqsSuccess = () => ({
    type: UPDATE_STORE_FAQS_SUCCESS,
});
export const updateStoreFaqsError = error => ({
    type: UPDATE_STORE_FAQS_ERROR,
    error: true,
    payload: error,
});

// ================ Selectors ================ //
export const getUpdateInProgress = state =>
    state.StoreFaqsPage?.updateInProgress || false;

export const getUpdateError = state =>
    state.StoreFaqsPage?.updateError;

// ================ Thunks ================ //

// loadData is a collection of async calls that need to be made
// before page has all the info it needs to render itself
export const loadData = (params, search, config) => (dispatch, getState) => {
    // No additional data loading required for this page
    return Promise.resolve();
};

// Update Store FAQs - handles FAQ updates and profile update
export const updateStoreFaqs = (formValues, currentUser) => {
    return async (dispatch, getState, sdk) => {
        dispatch(updateStoreFaqsRequest());

        try {
            const {
                faqs,
            } = formValues;

            // Filter out empty FAQs and validate
            const validFaqs = faqs.filter(faq => 
                faq.question && faq.question.trim() !== '' && 
                faq.answer && faq.answer.trim() !== ''
            );

            // Prepare publicData payload
            const publicDataPayload = {
                storeFaqs: validFaqs,
            };

            const payload = {
                publicData: publicDataPayload,
            };

            // Call updateProfile thunk from ProfileSettingsPage
            await dispatch(updateProfileAction(payload));

            dispatch(updateStoreFaqsSuccess());
            return true;
        } catch (error) {
            console.error('Error updating store FAQs:', error);
            const storableErr = storableError(error);
            dispatch(updateStoreFaqsError(storableErr));
            return false;
        }
    };
};
